const LoadingKeyboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="none">
    <path
      fill="#825DC4"
      d="m28.374 22.19 1.239-4.032-4.493 2.13L4.744 55.18l65.131-8.77-41.5-24.22Z"
    />
    <path
      fill="#825DC4"
      d="m102.102 103.492 16.661-28.54L69.875 46.41 4.744 55.18l93.643 54.662 4.507-2.116-.792-4.234Z"
    />
    <path
      className="anim-fill"
      fill="#00F1A3"
      d="M123.255 72.82 29.606 18.162 9.24 53.06l93.648 54.658 20.368-34.898Z"
    />
    <path
      fill="#825DC4"
      d="M32.349 30.873a3.946 3.946 0 1 0 0-7.891 3.946 3.946 0 0 0 0 7.89ZM114.745 78.969a3.946 3.946 0 1 0 0-7.892 3.946 3.946 0 0 0 0 7.892ZM47.052 31.76l-4.44-2.592-2.592 4.44 4.44 2.591 2.592-4.44ZM54.53 36.12l-4.44-2.592-2.59 4.44 4.44 2.592 2.59-4.44ZM62.012 40.487l-4.44-2.591-2.592 4.44 4.44 2.591 2.592-4.44Z"
    />
    <path
      fill="#FEF5D2"
      d="M33.616 34.192 19.207 58.879l9.24 5.393 14.41-24.687-9.241-5.393ZM42.868 39.586 28.459 64.272l9.24 5.394 14.41-24.687-9.241-5.393Z"
    />
    <path
      fill="#FEF5D2"
      d="M52.085 44.97 37.677 69.657l9.24 5.393 14.409-24.687-9.24-5.393ZM61.337 50.364 46.928 75.05l9.24 5.393 14.41-24.687-9.241-5.393Z"
    />
    <path
      fill="#FEF5D2"
      d="M70.577 55.75 56.169 80.437l9.24 5.393 14.408-24.687-9.24-5.393Z"
    />
    <path
      fill="#FEF5D2"
      d="M79.807 61.156 65.398 85.843l9.24 5.393 14.41-24.687-9.241-5.393Z"
    />
    <path
      fill="#FEF5D2"
      d="M89.046 66.543 74.637 91.229l9.24 5.394 14.41-24.687-9.241-5.393ZM98.29 71.934 83.883 96.621l9.24 5.393 14.409-24.687-9.24-5.393Z"
    />
    <path
      fill="#000"
      d="m45.096 40.88-4.452-2.598-8.616 14.762 4.452 2.599 8.616-14.763ZM54.328 46.268l-4.452-2.599-8.616 14.763 4.452 2.598 8.616-14.762ZM72.93 57.132l-4.453-2.599-8.616 14.763 4.452 2.598 8.616-14.762ZM82.154 62.518l-4.452-2.6-8.616 14.763 4.452 2.599 8.616-14.762ZM91.15 67.778l-4.452-2.599-8.616 14.762 4.453 2.599 8.616-14.762ZM100.516 73.235l-4.453-2.599-8.616 14.762 4.453 2.599 8.616-14.762Z"
    />
    <path
      fill="#825DC4"
      d="M110.438 68.877 67.444 43.783l-1.052 1.804 42.993 25.093 1.053-1.803ZM108.608 72.007 65.615 46.914l-1.053 1.803 42.994 25.093 1.052-1.803Z"
    />
    <path
      fill="#FEF5D2"
      d="M35.085 26.236s-.1-.043-.144-.072v-.014a2.504 2.504 0 0 0-.418-1.037 2.41 2.41 0 0 0-.835-.734 2.505 2.505 0 0 0-1.066-.288c-.374 0-.748.057-1.094.216-.043-.03-.086-.058-.144-.087l-.288-.158-.288.547c-.173 0-.346.029-.504.115a.902.902 0 0 0-.36.375.897.897 0 0 0-.115.504c0 .172.072.345.173.49v.014a2.493 2.493 0 0 0-.188 1.872c.188.619.62 1.152 1.181 1.454a2.45 2.45 0 0 0 3.326-1.008c.174 0 .346-.029.505-.115a.902.902 0 0 0 .36-.375.885.885 0 0 0 .1-.504.878.878 0 0 0-.172-.49l.288-.546-.303-.159h-.014Zm-3.096-1.44c.23-.072.475-.1.705-.072.245.029.476.087.692.202a1.7 1.7 0 0 1 .547.46c.158.188.26.404.331.634v.029h-.014c-.101 0-.216 0-.317.029a2.338 2.338 0 0 0-.763-.691 2.376 2.376 0 0 0-1.008-.26c-.044-.1-.101-.187-.159-.273v-.029l-.014-.029Zm1.713 3.312c-.23.418-.604.735-1.065.879-.46.144-.95.086-1.354-.13a1.78 1.78 0 0 1-.864-1.066c-.13-.46-.086-.95.144-1.368l.735-1.382h.014c.23.23.331.677.36.778.187-.058.389-.072.59-.044.202.03.39.087.562.188.173.086.331.216.46.374.13.158.231.331.289.518.1-.043.518-.201.835-.13h.029l-.734 1.383ZM117.438 74.347s-.1-.044-.144-.072v-.015a2.495 2.495 0 0 0-.417-1.037 2.411 2.411 0 0 0-.835-.734 2.51 2.51 0 0 0-1.066-.288c-.374 0-.749.058-1.094.216-.044-.029-.087-.058-.144-.087l-.288-.158-.288.547c-.173 0-.346.03-.504.116a.896.896 0 0 0-.36.374.896.896 0 0 0-.116.504c0 .173.072.346.173.49v.014a2.495 2.495 0 0 0-.187 1.872c.187.62.619 1.152 1.181 1.454a2.448 2.448 0 0 0 3.326-1.008c.173 0 .346-.028.504-.115a.896.896 0 0 0 .36-.374.884.884 0 0 0 .101-.504.877.877 0 0 0-.173-.49l.288-.547-.302-.158h-.015Zm-3.096-1.44c.231-.072.476-.101.706-.072.245.028.475.086.691.201a1.7 1.7 0 0 1 .547.46c.159.188.26.404.332.635v.028h-.015c-.101 0-.216 0-.317.03a2.325 2.325 0 0 0-.763-.692 2.374 2.374 0 0 0-1.008-.26c-.043-.1-.101-.186-.158-.273v-.029l-.015-.029Zm1.714 3.312c-.23.417-.605.734-1.066.878a1.76 1.76 0 0 1-1.353-.13 1.778 1.778 0 0 1-.864-1.065c-.13-.461-.087-.95.144-1.368l.734-1.383h.015c.23.23.331.677.36.778.187-.058.388-.072.59-.043.202.029.389.086.562.187.172.086.331.216.46.374.13.159.231.331.288.519.101-.043.519-.202.836-.13h.028l-.734 1.383Z"
    />
  </svg>
);
export default LoadingKeyboard;
